import React, { memo, useState, useCallback } from "react";
import ImageLoaderSkeleton from "./imageLoaderSkeleton";

const ImageWithLoader = ({ className, src, alt }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleImageLoad = useCallback(() => {
    setIsLoading(false);
    setHasError(false);
  }, []);

  const handleImageError = useCallback(() => {
    setIsLoading(false);
    setHasError(true);
  }, []);

  return (
    <div className="relative">
      {isLoading && !hasError && <ImageLoaderSkeleton />}

      {/* Always render the image but hide it while loading */}
      <img
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        onError={handleImageError}
        className={className}
        style={{ display: isLoading ? "none" : "block" }}
      />

      {hasError && <div className="text-red-500">Failed to load image.</div>}
    </div>
  );
};

export default memo(ImageWithLoader);